import { ItemProps } from '@@/form-components/InputList';
import { InputGroup } from '@@/form-components/InputGroup';

export function FlexDriverItem({ item, onChange, index }: ItemProps<string>) {
  return (
    <InputGroup size="small" className="flex-1">
      <InputGroup.Addon>Driver</InputGroup.Addon>
      <InputGroup.Input
        type="text"
        className="form-control"
        value={item}
        onChange={(e) => onChange(e.target.value)}
        data-cy={`allowed-flex-volume-driver-${index}-input`}
      />
    </InputGroup>
  );
}
